(function() {
  'use strict';

  angular.module('traineeWebApp.config', []).value('traineeWebAppConfig', {});
  angular.module('traineeWebApp.main', ['traineeWebApp.config']);
  angular.module('account.resolveAccount', ['traineeWebApp.config']);
  angular.module('factories.serviceLocator', ['traineeWebApp.config']);
  angular.module('traineeWebApp.services', ['traineeWebApp.config']);
  angular.module('traineeWebApp.dashboard', ['traineeWebApp.config', 'ngSanitize', 'ngMessages']);
  angular.module('traineeWebApp.resources', ['traineeWebApp.config']);
  angular.module('mfTrainee.consts', []).value('mfTrainee.consts', {});
  angular.module('traineeWebApp.consts', []).value('traineeWebApp.consts', {});
  angular.module('traineeWebApp.handout', []);
  angular.module('traineeWebApp.uploadedContents', []);

  angular.module('traineeWebApp', [
    'ngTouch',
    'ui.sortable',
    'ngSanitize',
    'mfTrainee.consts',
    'traineeWebApp.consts',
    'ui.bootstrap',
    'ui.bootstrapBtn',
    'traineeWebApp.resources',
    'traineeWebApp.main',
    'traineeWebApp.dashboard',
    'traineeWebApp.handout',
    'traineeWebApp.uploadedContents',
    'mfTrainee.directives',
    'mfTrainee.filters',
    'services.sessionExpiration',
    'services.sprintfService',
    'services.translationService',
    'service.account',
    'service.actionLog',
    'service.fileupload',
    'ngCookies',
    'ngRoute',
    'account.resolveAccount',
    'factories.serviceLocator',
    'traineeWebApp.services',
    'modals.editProfile',
    'modals.addLink',
    'service.yammer',
    'service.crocodoc',
    'utils.urlUtil',
    'utils.htmlPartialScriptLoader',
    'gettext',
    '$traineePlayer'
  ]);

  angular.module('traineeWebApp').config(['$routeProvider', '$locationProvider', '$httpProvider', function($routeProvider, $locationProvider, $httpProvider) {

    var resolveAccount = function(ResolveAccount) {
      return ResolveAccount();
    };
    resolveAccount.$inject = ['ResolveAccount'];

    $routeProvider
      .when('/player/:cModuleId', { //TODO: Remove
        templateUrl: 'contentPlayer/contentContainer.html',
        reloadOnSearch: false,
        pageName: "Module",
        controller: 'ContentPlayerCtrl',
        contentType: mfConfig.role === 'SME' ? 'PreviewContentPlayerService' : 'ContentPlayerService',
        resolve: { ContentPlayerService: resolveAccount }
      })
      .when('/player/module/:cModuleId/course/:courseId', {
        templateUrl: 'contentPlayer/contentContainer.html',
        reloadOnSearch: false,
        pageName: "Module",
        controller: 'ContentPlayerCtrl',
        contentType: mfConfig.role === 'SME' ? 'PreviewContentPlayerService' : 'ContentPlayerService',
        resolve: { ContentPlayerService: resolveAccount }
      })
      .when('/', {
        templateUrl: 'dashboard/dashboard.html',
        pageName: "Dashboard",
        controller: 'DashboardCtrl',
        resolve: { ContentPlayerService: resolveAccount }
      })
      .when('/TMS/CModule/:cModuleId', {
        caseInsensitiveMatch: true,
        redirectTo: function(args) {
          return '/player/' + args.cModuleId;
        },
        resolve: { ContentPlayerService: resolveAccount }
      })
      .when('/TMS/CModule/:cModuleId/Preview', {
        caseInsensitiveMatch: true,
        redirectTo: function(args) {
          return '/preview/' + args.cModuleId;
        },
        resolve: { ContentPlayerService: resolveAccount }
      })
      .when('/preview/:cModuleId', {
        templateUrl: 'contentPlayer/contentContainer.html',
        controller: 'ContentPlayerCtrl',
        reloadOnSearch: false,
        pageName: "Module",
        contentType: 'PreviewContentPlayerService',
        resolve: { ContentPlayerService: resolveAccount }
      })
      .otherwise({
        redirectTo: '/'
      });
  }]).run(['$window', 'Auth', 'AccountService', '$rootScope', 'MobileHelper', '$location', function($window, Auth, AccountService, $rootScope, MobileHelper, $location) {

    $rootScope.refreshed = $location.search().refreshed;
    $location.search('refreshed', null);
    $location.replace();

    if ($window.navigator.userAgent.match(/Android 2./i))
      $('html').addClass('no-overflowscrolling');

    if (MobileHelper.isAndroidDefaultBrowser())
      $('html').addClass('android-default-browser');

    // iPad app determines if there's connectivity natively.
    // Nothing to do that on web so just always assume connected.
    $window.isConnected = true;     // I know a guy...
    $window._gaq = $window._gaq || [];
    mfConfig.traineeDomain = $window.location.host;

    var iOSVersionString = $window.navigator.userAgent.match(/(iPad|iPhone);.*CPU.*OS \d_+\d+/i);
    if (iOSVersionString && iOSVersionString.length > 0 && parseInt(iOSVersionString[0].substring(13, 14)) == 7)
      $('body').addClass('ios7');

    var isIos = $window.navigator.userAgent.match(/(iPad|iPhone)/i) != null;
    if (isIos) {
      $('body').addClass('mobile-ios');
    }

    if ($window.Modernizr && $window.Modernizr.touch) {
      $(document).on('blur', 'input, textarea', function() {
        setTimeout(function() {
          $window.scrollTo($window.document.body.scrollLeft, $window.document.body.scrollTop);
        }, 0);
      });
    }

    if (mfConfig.sessionId) {
      Auth.setHeaderSessionId(mfConfig.sessionId);
    } else {
      $window.location = '/';
    }
  }])
    .constant('trainerPreview', !!~(window || { location: {} }).location.toString().toLowerCase().indexOf('/preview'))
    .value('scriptsForPartial', {
      'newDocument/newDocument.html': {
        src: 'bower_components/viewer/dist/crocodoc.viewer.min.js', loaded: false
      }
    });


// Error handling for js errors
  angular.module('traineeWebApp').factory('stacktraceService',
    function() {
      // 'printStackTrace' is a global object
      return ({
        print: printStackTrace
      });
    }
  );

  angular.module('traineeWebApp').provider('$exceptionHandler', {
      $get: ['errorLogService', function(errorLogService) {
        return ( errorLogService );
      }]
    }
  );

  angular.module('traineeWebApp').factory('errorLogService',
    ['$log', '$window', 'stacktraceService', '$injector', function($log, $window, stacktraceService, $injector) {
      function log(exception, cause) {

        $log.error.apply($log, arguments);

        try {
          var errorMessage = exception.toString();
          var stackTrace = stacktraceService.print({ e: exception }) || [];
          var rootScope = $injector.get('$rootScope') || {};
          var navigation = $injector.get('Navigation') || {};
          var $http = $injector.get('$http') || {};

          var addinfo = {};
          addinfo.cause = cause;
          addinfo.userAgent = navigator.userAgent;

          addinfo.url = $window.location.href;
          if (navigation && navigation.slideIndex !== undefined) {
            addinfo.url += '/slide' + navigation.slideIndex;
          }

          var stack = stackTrace.join('\n');
          getContentPlayerData(addinfo);
          getVideoData(addinfo);
          getDocumentData(addinfo);

          addinfo.hasFlash = $window.swfobject && $window.swfobject.hasFlashPlayerVersion('10.1');

          addinfo.canPlayHtml5Video = false;
          if ($window.Modernizr && $window.Modernizr.video)
            addinfo.canPlayHtml5Video = $window.Modernizr.video.h264;

          addinfo.canPlayHtml5Audio = false;
          if ($window.Modernizr && $window.Modernizr.audio)
            addinfo.canPlayHtml5Audio = $window.Modernizr.audio.mp3;

          if ($window.mfConfig)
            addinfo.mfConfig = $window.mfConfig;

          if ($window.performance && $window.performance.timing) {
            var timing = $window.performance.timing;
            if (timing.responseEnd)
              addinfo.responseTime = (timing.responseEnd - timing.fetchStart) + 'ms';
            if (timing.loadEventEnd)
              addinfo.pageLoadTime = (timing.loadEventEnd - timing.responseEnd) + 'ms';
          }

          var data = _.defaults({
            message: errorMessage || '',
            stack: stack,
            application: 'mfTraineeWeb',
          }, addinfo);

          if ($http.post) {
            $http.post('/gaviota-api/log', data, angular.noop, angular.noop);
          }
        }
        catch (e) {
          // For Developers - log the log-failure.
          $log.warn("Error logging failed");
          $log.log(e);
        }
      }

      function getContentPlayerData(extraData) {
        if (angular.element('#slideViewer') &&
          angular.element('#slideViewer').scope()) {
          var scope = angular.element('#slideViewer').scope();

          if (scope.currentSlide)
            extraData.currentSlide = scope.currentSlide;

          var cModuleCompleted = !!scope.completionInfo;
          if (!_.isUndefined(cModuleCompleted))
            extraData.cModuleCompleted = cModuleCompleted;

          if (scope.lastLoadStep)
            extraData.lastLoadStep = scope.lastLoadStep;
        }
        return extraData;
      }

      function getVideoData(extraData) {
        if (angular.element('#videoContainer') &&
          angular.element('#videoContainer').scope() &&
          angular.element('#videoContainer').scope().lastLoadStep) {
          var scope = angular.element('#videoContainer').scope();

          extraData.videoFullError = scope.videoFullError;
          extraData.videoLastLoadStep = scope.lastLoadStep;
          extraData.videoSource = scope.mediaState.videoSrc;

          try {
            if (scope.mediaControl) {
              if (scope.mediaControl.getCurrentTime)
                extraData.videoCurrentTime = scope.mediaControl.getCurrentTime();
              if (scope.mediaControl.getDuration)
                extraData.videoDuration = scope.mediaControl.getDuration();
            }
          } catch (e) {
            extraData.videoError = 'Error getting current time and duration for video';
          }
        }
        return extraData;
      }

      function getDocumentData(extraData) {
        if (angular.element('#doc-container') &&
          angular.element('#doc-container').scope() &&
          angular.element('#doc-container').scope().lastLoadStep) {
          var scope = angular.element('#doc-container').scope();

          extraData.documentLastLoadStep = scope.lastLoadStep;

          if (scope.session)
            extraData.documentSessionInfo = scope.session;
        }
        return extraData;
      }

      // Return the logging function.
      return ( log );
    }]
  );
})();
